export class Exportfragebogen {
    lieferantName: string;
    lieferantNummer: string;
    fragebogenName: string;
    typ: string;
    ablaufdatum: string;
    status: string;
    vonPflichtBefreit: string;
    fragetyp: string;
    fragestellung: string;
    antwort:string;
    gewaehlt:string;
    abgeschlossen:string;
}